export class Client {
    constructor(
    public id ?: number,
    public name ?: string,
    public secret ?: string,
    public redirect ?: string
    ) {}
}
